// extracted by mini-css-extract-plugin
module.exports = {"icon":"sozial-module--icon--34eI6","link":"sozial-module--link--2qLfW","sozialLinks":"sozial-module--sozial-links--1GNSs"};